module.exports = __webpack_public_path__ + "img/tag_editor_modal.335b5263.webp";